export const defaultFormatters = {
    yearFormat: "%Y",
    quarterFormat: "%b",
    monthFormat: "%b",
    weekFormat: "%e",
    dayFormat: "%e",
    hourFormat: "%H:%M",
    minuteFormat: "%H:%M",
    secondFormat: "%H:%M:%S",
    milliSecondFormat: "%L",
};
export const levelDefinition = [
    /* 19 */ (d, date, i) => d.startOfYear && date.getFullYear() % 12 === 0 && "yearFormat",
    /* 18 */ (d, date, i) => d.startOfYear && date.getFullYear() % 4 === 0 && "yearFormat",
    /* 17 */ (d, date, i) => d.startOfYear && date.getFullYear() % 2 === 0 && "yearFormat",
    /* 16 */ (d, date, i) => d.startOfYear && "yearFormat",
    /* 15 */ (d, date, i) => d.startOfQuarter && "quarterFormat",
    /* 14 */ (d, date, i) => d.startOfMonth && "monthFormat",
    /* 13 */ (d, date, i) => d.startOfWeek && "weekFormat",
    /* 12 */ (d, date, i) => d.startOfDay && i % 2 === 0 && "dayFormat",
    /* 11 */ (d, date, i) => d.startOfDay && "dayFormat",
    /* 10 */ (d, date, i) => d.startOfHalfDay && "hourFormat",
    /*  9 */ (d, date, i) => d.startOfQuarterDay && "hourFormat",
    /*  8 */ (d, date, i) => d.startOfEighthOfADay && "hourFormat",
    /*  7 */ (d, date, i) => d.startOfHour && date.getHours() % 2 === 0 && "hourFormat",
    /*  6 */ (d, date, i) => d.startOfHour && "hourFormat",
    /*  5 */ (d, date, i) => d.startOf30Minutes && "minuteFormat",
    /*  4 */ (d, date, i) => d.startOf15Minutes && "minuteFormat",
    /*  3 */ (d, date, i) => d.startOf5Minutes && "minuteFormat",
    /*  2 */ (d, date, i) => d.startOfMinute && "minuteFormat",
    /*  1 */ (d, date, i) => d.startOf30Seconds && "secondFormat",
    /*  0 */ (d, date, i) => "secondFormat",
];
//# sourceMappingURL=levels.js.map